import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import pop_default_01 from '../lottie_files/pop_default_01.json';
import pop_blue_01 from '../lottie_files/pop_blue_01.json';
import pop_green_01 from '../lottie_files/pop_green_01.json';
import pop_olive_01 from '../lottie_files/pop_olive_01.json';
import pop_orange_01 from '../lottie_files/pop_orange_01.json';
import pop_pink_01 from '../lottie_files/pop_pink_01.json';
import pop_purple_01 from '../lottie_files/pop_purple_01.json';
import pop_red_01 from '../lottie_files/pop_red_01.json';
import pop_teal_01 from '../lottie_files/pop_teal_01.json';
import pop_yellow_01 from '../lottie_files/pop_yellow_01.json';

const animationMap = {
    default: pop_default_01,
    purple: pop_purple_01,
    blue: pop_blue_01,
    green: pop_green_01,
    olive: pop_olive_01,
    orange: pop_orange_01,
    pink: pop_pink_01,
    red: pop_red_01,
    teal: pop_teal_01,
    yellow: pop_yellow_01,
};

const PopAnimation = ({ loggedIn, popColor, inOverlay }) => {
    const lottieContainer = useRef(null);

    useEffect(() => {
        const animationData = !loggedIn ? animationMap["purple"] : !popColor ? animationMap["default"] : animationMap[popColor.toLowerCase()] || animationMap["purple"];

        const anim = lottie.loadAnimation({
            container: lottieContainer.current,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            animationData: animationData
        });

        return () => anim.destroy();
    }, [popColor]);

    return (
        <div
            ref={lottieContainer}
            style={{
                height: inOverlay ? '400px' : '600px',
                width: inOverlay ? '400px' : '600px',
            }}
        />
    );
};

export default PopAnimation;